import { DataObject } from '../data-object.model';

export const QUEUES_STATE = 'queues_state';

/* Interface describing the signature of queues state storing into local storage */
export interface QueuesState {
  sortOptions: DataObject;
  filters: DataObject;
}
